import { Component, DoCheck, signal, WritableSignal } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { EncodeErrorInfo, EnumEncodeError } from '../../modules/buildings-shared/model/encode-error-info';
import { SharedUtils } from '../../modules/buildings-shared/utilities/shared-utils';
import { UserInfo } from '../../modules/buildings-shared/model/user-info';

@Component({
  selector: 'app-password-forgot',
  imports: [FormsModule, RouterLink, RouterLinkActive],
  templateUrl: './password-forgot.component.html',
  styleUrl: './password-forgot.component.scss'
})
export class PasswordForgotComponent {
    userEmail: string = '';
    error: WritableSignal<boolean>= signal<boolean>(false);
    buttonDisabled: WritableSignal<boolean> = signal<boolean>(false);

    constructor(private readonly permissionService: PermissionService, private readonly router: Router) { }

    onSubmit(form: NgForm): void {
        this.permissionService.setWaitingSpinner(true);
        // console.log("PasswordForgotComponent.onSubmit(). userEmail: " + this.userEmail);
        this.userEmail = form.value.email;
        this.permissionService.forgotPassword(this.userEmail).then( (result: boolean) => {
            if(!!result) {
                // console.log("PasswordForgotComponent.onSubmit(). RESULT OK");
                this.router.navigateByUrl("forgotPasswordComplete/" + result + "/" + this.userEmail);
            } else {
                // console.log("PasswordForgotComponent.onSubmit(). RESULT KKKOOO");
                this.router.navigateByUrl("forgotPasswordComplete/" + false);
            }
            this.permissionService.setWaitingSpinner(false);
        }).catch( (error: any) => {
            const returnedError: EncodeErrorInfo = error.error;
            // console.error("LoginComponent.onSubmit() - An error occurred: " + JSON.stringify(error));
            // console.error("LoginComponent.onSubmit() - An error occurred: " + (returnedError.code ?? (returnedError.message ?? (error.code ?? error.message) ) ) );
            if ( SharedUtils.inputValueIsPresent(returnedError?.code) ) {
                // console.log("PasswordForgotComponent.onSubmit(). SWITCH ERROR CODE");
                switch(returnedError?.code) {
                    case EnumEncodeError.EMAIL_NOT_FOUND: {
                        this.permissionService.alert("Attenzione: email non trovata");
                        break;
                    }
                    default: {
                        // console.error("ProfileAccount.onChangeUserRoleClose() - error code message: " + returnedError?.code);
                        this.permissionService.alert("Attenzione: si è verificato un errore. Riprovare più tardi o contattare l'assistenza.");
                        break;
                    }
                }
            } else {
                console.error("LoginComponent.onSubmit() - Login error: " + (JSON.stringify(error)) );
                this.router.navigateByUrl("forgotPasswordComplete/" + false);
            }
        }).finally(() => {
            this.permissionService.setWaitingSpinner(false);
            form.controls['email'].updateValueAndValidity();
            this.error.set(true);
            this.buttonDisabled.set(true);
            setTimeout(() => {
                this.buttonDisabled.set(false);
            }, 4000);
        });
    }
}